// import React, { useState, useEffect } from 'react';
// import { Download, Search, ChevronRight, ChevronLeft } from 'lucide-react';
// import CoordinatorHandler from "../components/CoordinatorHandler";
// import { API_BASE_URL } from '../../Api/apiconnector';
// import { useNavigate } from 'react-router-dom';



// const PdfPage  = () => {
//   const [reports, setReports] = useState([]);
//   const [nextCursor, setNextCursor] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterInstitution, setFilterInstitution] = useState('All');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedReports, setSelectedReports] = useState([]);
//   const [sending, setSending] = useState({}); // map of sending states per row, keys like `${id}-email` or `${id}-whatsapp`
//   const itemsPerPage = 200;
//   const [institutions, setInstitutions] = useState([]);
//   const [loadingInstitutions, setLoadingInstitutions] = useState(false);
//   const [filterModality, setFilterModality] = useState("All");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [calendarDate, setCalendarDate] = useState(""); // NEW: for the calendar input
//   const [isSearching, setIsSearching] = useState(false);
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
//   const navigator = useNavigate();
//   const [darkMode, setDarkMode] = useState(() => {
//     try {
//       return JSON.parse(localStorage.getItem('pdfpage_darkmode')) || false;
//     } catch {
//       return false;
//     }
//   });

//   useEffect(() => {
//     try {
//       localStorage.setItem('pdfpage_darkmode', JSON.stringify(darkMode));
//     } catch {}
//   }, [darkMode]);

//   useEffect(() => {
//     loadInitialData();
//     loadInstitutions();
//   }, []);



//   const loadInitialData = async () => {
//     setLoading(true);
//     setError(null);
//     setIsInitialLoad(true); 
//     try {
//       const data = await CoordinatorHandler.fetchCompletedTatCounters(itemsPerPage);
//       console.log('Fetched data:', data);
//       setReports((data.results || []).map(r => {
//         // keep backward compatibility: if backend now returns report_url/report_title
//         if (!Array.isArray(r.patient_reports)) {
//           if (r.report_url) {
//             return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
//           }
//           return { ...r, patient_reports: [] };
//         }
//         return r;
//       }));
//       setNextCursor(data.next_cursor);
//     } catch (err) {
//       setError('Failed to load data. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadMoreData = async () => {
//     if (!nextCursor || loading) return;
    
//     setLoading(true);
//     try {
//       const data = await CoordinatorHandler.fetchCompletedTatCounters(itemsPerPage, nextCursor);
//       setReports(prev => [...prev, ...((data.results || []).map(r => {
//         if (!Array.isArray(r.patient_reports)) {
//           if (r.report_url) {
//             return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
//           }
//           return { ...r, patient_reports: [] };
//         }
//         return r;
//       }))]);
//       setNextCursor(data.next_cursor);
//       setCurrentPage(prev => prev + 1);
//     } catch (err) {
//       setError('Failed to load more data.');
//     } finally {
//       setLoading(false);
//     }
//   };




// const modalities = Array.from(
//   new Set(reports.map(r => r.modality).filter(Boolean))
// );

  

//   // Helper: normalize a single report object so the UI can always rely on
//   // `patient_reports` being an array of { url, title } objects.
//   // New backend shape: report_url, report_title at top-level.
//   // Old backend shape: patient_reports: [{ url }]
//   const normalizeReport = (r) => {
//     if (Array.isArray(r.patient_reports)) return r;
//     if (r.report_url) return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
//     return { ...r, patient_reports: [] };
//   };

//   // Send report PDF by email. Uses endpoint: POST /api/email-pdf-raw/<patient_id>/ with payload { email, name, pdf_url }
//   const sendEmail = async (report) => {
//     const pdf = report.patient_reports?.[0]?.url;
//     if (!pdf) {
//       alert('No PDF available to send.');
//       return;
//     }
//     const key = `${report.id}-email`;
//     setSending(prev => ({ ...prev, [key]: true }));
//     const payload = {
//       email: report.email || '',
//       name: report.patient_name || '',
//       pdf_key: pdf,
//     };
//     try {
//       const res = await CoordinatorHandler.sendEmailPdfRaw(report.patient_id || '', payload);
//       if (!res.success) throw new Error(res.error || 'Server error');
//       alert('Email API triggered successfully.');
//     } catch (err) {
//       console.error('sendEmail error', err);
//       alert('Failed to trigger email API. Check console for details.');
//     } finally {
//       setSending(prev => ({ ...prev, [key]: false }));
//     }
//   };

//   // Send report PDF via WhatsApp. Uses endpoint: POST /api/send-whatsapp/ with payload { whatsapp_number, patient_name, pdf_url, patient_id }
//   const sendWhatsapp = async (report) => {
//     const pdf = report.patient_reports?.[0]?.url;
//     if (!pdf) {
//       alert('No PDF available to send.');
//       return;
//     }
//     const key = `${report.id}-whatsapp`;
//     setSending(prev => ({ ...prev, [key]: true }));
//     const payload = {
//       whatsapp_number: report.whatsapp_number || report.whatsapp || '',
//       patient_name: report.patient_name || '',
//       pdf_key: pdf,
//       patient_id: report.patient_id || '',
//     };
//     try {
//       const res = await CoordinatorHandler.sendWhatsapp(payload);
//       if (!res.success) throw new Error(res.error || 'Server error');
//       alert('WhatsApp API triggered successfully.');
//     } catch (err) {
//       console.error('sendWhatsapp error', err);
//       alert('Failed to trigger WhatsApp API. Check console for details.');
//     } finally {
//       setSending(prev => ({ ...prev, [key]: false }));
//     }
//   };

//   const downloadReport = async (url, fileName) => {
//     try {
//       const response = await fetch(url);
//       const blob = await response.blob();
//       const blobUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = fileName || 'report.pdf';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);
//     } catch (err) {
//       console.error('Download failed:', err);
//       // Fallback: open in new tab if download fails
//       window.open(url, '_blank');
//     }
//   };

//   const handleDownloadAllReports = (report) => {
//     if (report.patient_reports && report.patient_reports.length > 0) {
//       report.patient_reports.forEach((rep, idx) => {
//         setTimeout(() => {
//           const fileName = `${report.patient_id || 'Patient'}_${report.patient_name || 'Unknown'}_Report_${idx + 1}.pdf`;
//           downloadReport(rep.url, fileName);
//         }, idx * 500);
//       });
//     }
//   };

//   const translateToHindi = async (report) => {
//     try {
//       if (!report.report_id) {
//         alert("Report ID not found");
//         return;
//       }

//       const endpoint = `${API_BASE_URL}/reports/${report.report_id}/translate-hindi/`;
//       const response = await fetch(endpoint, {
//         method: "GET",
//         credentials: "include",
//       });

//       if (!response.ok) {
//         throw new Error("Hindi translation failed");
//       }

//       // Receive PDF as blob
//       const blob = await response.blob();

//       const blobUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");

//       const safeName = `${(report.patient_name || "Patient")
//         .replace(/\s+/g, "_")}_${report.patient_id}_HINDI.pdf`;

//       link.href = blobUrl;
//       link.download = safeName;

//       document.body.appendChild(link);
//       link.click();

//       link.remove();
//       window.URL.revokeObjectURL(blobUrl);

//     } catch (err) {
//       console.error("Hindi translation error:", err);
//       alert("Failed to generate Hindi report");
//     }
//   };


//   const handleSearch = async () => {
//   if (!searchTerm.trim()) {
//     // If search is empty, reload initial data
//     loadInitialData();
//     return;
//   }

//   setIsSearching(true);
//   setError(null);
  
//   try {
//     const searchResults = await CoordinatorHandler.searchReport(searchTerm);
    
//     // Normalize the results (same as in loadInitialData)
//     setReports((searchResults || []).map(r => {
//       if (!Array.isArray(r.patient_reports)) {
//         if (r.report_url) {
//           return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
//         }
//         return { ...r, patient_reports: [] };
//       }
//       return r;
//     }));
    
//     setNextCursor(null); // Clear pagination for search results
//     setIsInitialLoad(false);
//   } catch (err) {
//     console.error('Search error:', err);
//     setError('Failed to search. Please try again.');
//   } finally {
//     setIsSearching(false);
//   }
// };


//   const loadInstitutions = async () => {
//     setLoadingInstitutions(true);
//     try {
//       const data = await CoordinatorHandler.getAllInstitutions();
//       // Adjust based on your API response structure
//       // If API returns { results: [...] } or just an array
//       setInstitutions(Array.isArray(data) ? data : data.results || data.institutions || []);
//     } catch (err) {
//       console.error('Failed to load institutions:', err);
//     } finally {
//       setLoadingInstitutions(false);
//     }
//   };
// // Separate filter function for institution
// const filterByInstitution = (report) => {
//   if (filterInstitution === 'All') return true;
//   const reportInst = (report.institution_name || '').trim().toLowerCase();
//   const selectedInst = filterInstitution.trim().toLowerCase();
//   return reportInst === selectedInst;
// };

// // Separate filter function for search
// const filterBySearch = (report) => {
//   if (searchTerm === '') return true;
//   const term = searchTerm.toLowerCase();
//   const name = (report.patient_name || '').toLowerCase();
//   const id = (report.patient_id || '').toLowerCase();
//   return name.includes(term) || id.includes(term);
// };

// // Filter modality
// const filterByModality = (report) => {
//   if (filterModality === "All") return true;
//   return report.modality?.toLowerCase() === filterModality.toLowerCase();
// };
// const parseDDMMYYYY = (dateStr) => {
//   if (!dateStr || typeof dateStr !== "string") return null;

//   const parts = dateStr.trim().split("-");
//   if (parts.length !== 3) return null;

//   let [dd, mm, yyyy] = parts;

//   // Ensure proper padding
//   dd = dd.padStart(2, '0');
//   mm = mm.padStart(2, '0');

//   if (yyyy.length === 2) {
//     yyyy = `20${yyyy}`;
//   } else if (yyyy.length !== 4) {
//     return null;
//   }

//   // Validate ranges
//   const day = parseInt(dd, 10);
//   const month = parseInt(mm, 10);
//   const year = parseInt(yyyy, 10);

//   if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900) {
//     return null;
//   }

//   // Create date at midnight local time for consistent comparison
//   const date = new Date(year, month - 1, day);
  
//   // Verify the date is valid (handles invalid dates like 31-02-2025)
//   if (date.getDate() !== day || date.getMonth() !== month - 1) {
//     return null;
//   }

//   return date;
// };

// const filterByStudyDate = (report, startDate) => {
//   if (!startDate) return true;

//   const reportDate = parseDDMMYYYY(report.study_date);
//   const selectedDate = parseDDMMYYYY(startDate);

//   console.log('==================');
//   console.log('Report study_date:', report.study_date);
//   console.log('Parsed report date:', reportDate);
//   console.log('Selected date string:', startDate);
//   console.log('Parsed selected date:', selectedDate);

//   if (!reportDate || !selectedDate) {
//     console.log('❌ One or both dates failed to parse - SHOWING THIS ROW');
//     return true;
//   }

//   // Reset time to midnight for fair comparison
//   reportDate.setHours(0, 0, 0, 0);
//   selectedDate.setHours(0, 0, 0, 0);

//   // EXACT MATCH ONLY
//   const result = reportDate.getTime() === selectedDate.getTime();
  
//   console.log('Report date timestamp:', reportDate.getTime());
//   console.log('Selected date timestamp:', selectedDate.getTime());
//   console.log('Filter result (exact match only):', result);
//   console.log('==================');

//   return result;
// };




// const filteredReports = React.useMemo(() => {
//   return reports
//     .filter(filterByInstitution)
//     .filter(filterByModality)
//     .filter((report) => filterByStudyDate(report, startDate)) // pass startDate
//     .filter((report) =>
//       report.patient_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       report.patient_id?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
// }, [
//   reports,
//   filterInstitution,
//   filterModality,
//   startDate,
//   endDate,
//   searchTerm
// ]);


//   const handleSelectReport = (reportId) => {
//     setSelectedReports(prev => {
//       if (prev.includes(reportId)) {
//         return prev.filter(id => id !== reportId);
//       } else {
//         return [...prev, reportId];
//       }
//     });
//   };

//   const handleSelectAll = () => {
//     if (selectedReports.length === filteredReports.length) {
//       setSelectedReports([]);
//     } else {
//       setSelectedReports(filteredReports.map((r, idx) => `${r.patient_id}-${idx}`));
//     }
//   };

  


//   // const handleBulkDownload = async () => {
//   //   if (selectedReports.length === 0) {
//   //     alert("Please select at least one report");
//   //     return;
//   //   }
  
//   //   // Collect all pdf_keys of selected reports (these are S3 keys or whatever your backend expects)
//   //   const pdfKeys = [];
//   //   const nameMap = {}; // map key -> nice filename
//   //   reports.forEach((rep, idx) => {
//   //     if (selectedReports.includes(`${rep.patient_id}-${idx}`)) {
//   //       if (rep.patient_reports && rep.patient_reports.length > 0) {
//   //         rep.patient_reports.forEach((r, idx) => {
//   //           const key = r.url; // this is the file key you send to backend
//   //           if (!key) return;
//   //           pdfKeys.push(key);
//   //           // build a reasonable filename for the returned presigned url
//   //           // use patient name + id + index to avoid duplicates
//   //           const safeName = `${(rep.patient_id || 'Patient').replace(/\s+/g,'_')}_${(rep.patient_name || 'Unknown')}_Report_${idx+1}.pdf`;
//   //           nameMap[key] = safeName;
//   //         });
//   //       }
//   //     }
//   //   });
  
//   //   if (pdfKeys.length === 0) {
//   //     alert("No PDFs found in selected cases");
//   //     return;
//   //   }
  
//   //   try {
//   //     // NOTE: make sure this matches the exact URL you added in Django (include /api/ if required)
//   //     const endpoint = `${API_BASE_URL}/bulk-presigned-urls/`;
//   //     const resp = await fetch(endpoint, {
//   //       method: "POST",
//   //       headers: { "Content-Type": "application/json" },
//   //       body: JSON.stringify({ pdf_keys: pdfKeys }),
//   //       credentials: "include" // optional: keep if other endpoints require session auth
//   //     });
  
//   //     if (!resp.ok) {
//   //       const text = await resp.text().catch(() => null);
//   //       throw new Error(`Backend returned ${resp.status} ${text || ''}`);
//   //     }
  
//   //     const data = await resp.json();
//   //     const presigned = data.urls || [];
//   //     if (!Array.isArray(presigned) || presigned.length === 0) {
//   //       alert("No presigned URLs returned from server");
//   //       return;
//   //     }
  
//   //     // Download each presigned URL (serialized with short delay)
//   //     let delay = 0;
//   //     const DELAY_BETWEEN = 500; // ms between downloads (reduce/increase as needed)
//   //     presigned.forEach((item, idx) => {
//   //       const url = item.url;
//   //       const key = item.key;
//   //       const filename = nameMap[key] || (key ? key.split('/').pop() : `report_${idx+1}.pdf`);
  
//   //       // schedule the download
//   //       setTimeout(async () => {
//   //         try {
//   //           // use same download routine you already have
//   //           await downloadReport(url, filename);
//   //         } catch (err) {
//   //           console.error("Failed downloading", key, err);
//   //         }
//   //       }, delay);
  
//   //       delay += DELAY_BETWEEN;
//   //     });
  
//   //   } catch (err) {
//   //     console.error("Bulk download failed", err);
//   //     alert("Bulk download failed. See console for details.");
//   //   }
//   // };

//   // Download report WITH logo by calling Django API and downloading returned PDF
  

//   const handleBulkDownload = async () => {
//   if (selectedReports.length === 0) {
//     alert("Please select at least one report");
//     return;
//   }

//   // Collect all pdf_keys of selected reports
//   const pdfKeys = [];
//   const nameMap = {}; // map key -> nice filename
  
//   // Create a Set for faster lookup
//   const selectedSet = new Set(selectedReports);
  
//   filteredReports.forEach((rep, idx) => {
//     const reportId = `${rep.patient_id}-${idx}`;
    
//     if (selectedSet.has(reportId)) {
//       if (rep.patient_reports && rep.patient_reports.length > 0) {
//         rep.patient_reports.forEach((pdfReport, pdfIdx) => {
//           const key = pdfReport.url;
//           if (!key) return;
          
//           pdfKeys.push(key);
          
//           // Build unique filename
//           const safeName = `${(rep.patient_id || 'Patient')}_${(rep.patient_name || 'Unknown').replace(/\s+/g,'_')}_Report_${pdfIdx + 1}.pdf`;
//           nameMap[key] = safeName;
//         });
//       }
//     }
//   });

//   if (pdfKeys.length === 0) {
//     alert("No PDFs found in selected cases");
//     return;
//   }

//   console.log(`Downloading ${pdfKeys.length} PDFs from ${selectedReports.length} selected reports`);

//   try {
//     const endpoint = `${API_BASE_URL}/bulk-presigned-urls/`;
//     const resp = await fetch(endpoint, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ pdf_keys: pdfKeys }),
//       credentials: "include"
//     });

//     if (!resp.ok) {
//       const text = await resp.text().catch(() => null);
//       throw new Error(`Backend returned ${resp.status} ${text || ''}`);
//     }

//     const data = await resp.json();
//     const presigned = data.urls || [];
    
//     if (!Array.isArray(presigned) || presigned.length === 0) {
//       alert("No presigned URLs returned from server");
//       return;
//     }

//     console.log(`Received ${presigned.length} presigned URLs`);

//     // Download each presigned URL
//     let delay = 0;
//     const DELAY_BETWEEN = 500;
    
//     presigned.forEach((item, itemIdx) => {
//       const url = item.url;
//       const key = item.key;
//       const filename = nameMap[key] || (key ? key.split('/').pop() : `report_${itemIdx + 1}.pdf`);

//       setTimeout(async () => {
//         try {
//           await downloadReport(url, filename);
//           console.log(`Downloaded ${itemIdx + 1}/${presigned.length}: ${filename}`);
//         } catch (err) {
//           console.error("Failed downloading", filename, err);
//         }
//       }, delay);

//       delay += DELAY_BETWEEN;
//     });

//   } catch (err) {
//     console.error("Bulk download failed", err);
//     alert("Bulk download failed. See console for details.");
//   }
// };

//   const handleBulkDownloadWithLogo = async () => {
//     if (selectedReports.length === 0) {
//       alert("Please select at least one report");
//       return;
//     }

//     const selectedSet = new Set(selectedReports);

//     for (let idx = 0; idx < filteredReports.length; idx++) {
//       const rep = filteredReports[idx];
//       const reportId = `${rep.patient_id}-${idx}`;

//       if (selectedSet.has(reportId)) {
//         await downloadWithLogo(rep);
//         await new Promise(res => setTimeout(res, 800)); // optional delay
//       }
//     }
//   };
  
//   const downloadWithLogo = async (report) => {
//     try {
//       // get top 1 report
//       const pdfKey = report?.patient_reports?.[0]?.url;
//       if (!pdfKey) {
//         alert("PDF not available");
//         return;
//       }
  
//       // Hit Django API to generate merged PDF with logo
//       const endpoint = `${API_BASE_URL}/download-with-logo/`;
//       const res = await fetch(endpoint, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           pdf_key: pdfKey,
//           patient_id: report.patient_id,
//           patient_name: report.patient_name
//         }),
//       });
  
//       if (!res.ok) {
//         throw new Error(`Server returned ${res.status}`);
//       }
  
//       // Get file blob
//       const blob = await res.blob();
//       const blobUrl = window.URL.createObjectURL(blob);
  
//       // Prepare download
//       const link = document.createElement("a");
//       // const safeName = `${(report.patient_name || "Patient").replace(/\s+/g, '_')}_${report.patient_id}_WITH_LOGO.pdf`;
//       const safeName = `${report.patient_id}_${(report.patient_name || "Patient").replace(/\s+/g, '_')}_WITH_LOGO.pdf`;
  
//       link.href = blobUrl;
//       link.download = safeName;
//       document.body.appendChild(link);
//       link.click();
  
//       // Clean
//       link.remove();
//       window.URL.revokeObjectURL(blobUrl);
  
//     } catch (err) {
//       console.error("Download-with-logo failed:", err);
//       alert("Failed to download report with logo");
//     }
//   };


//   return (
    
//     <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
//       {/* Header */}
//       <header className={`px-6 py-4 flex justify-between items-center ${darkMode ? 'bg-gray-800 text-white border-b border-gray-700' : 'bg-white text-gray-900 border-b border-gray-200'}`}>
//         <div className="flex items-center gap-4">
         
//           <img
//             src="https://u4rad.com/static/media/Logo.c9920d154c922ea9e355.png"
//             alt="U4rad"
//             style={{
//               height: 50,
//               backgroundColor: darkMode ? 'white' : 'transparent',
//               borderRadius: 6,
//               padding: 2
//             }}
//           />
//         </div>

//         <div className="flex items-center gap-3">
//           <button
//             onClick={() => setDarkMode(!darkMode)}
//             className={`px-3 py-2 rounded text-sm ${darkMode ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-700'}`}>
//             {darkMode ? '☀️' : '🌙'}
//           </button>
//           <button
//             onClick={() => navigator(-1)}
//             title="Go back"
//             className={`flex items-center justify-center w-25 h-10 rounded-md text-sm ${darkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
//             <ChevronLeft size={18} />
//             Go Back
//           </button>
//           <button onClick={() => navigator('/')} className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded text-sm text-white">
//             Logout
//           </button>
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="p-6">
//         {/* Stats and Controls */}
//         <div className={`rounded-lg shadow mb-6 p-4 ${darkMode ? 'bg-gray-800 text-white border border-gray-700' : 'bg-white text-gray-900'}`}>
//           <div className="flex justify-between items-center flex-wrap gap-4">
//             <div className="text-sm flex items-center gap-4">
//               <span className="font-semibold">Total XRAY Reports: {reports.length}</span>
//               {selectedReports.length > 0 && (
//                 <span className="text-blue-600 font-semibold">
//                   {selectedReports.length} Selected
//                 </span>
//               )}
//             </div>
            
//             <div className="flex gap-2 items-center flex-wrap">
//              <input
//                type="text"
//                placeholder="Search by name or ID"
//                value={searchTerm}
//                onChange={(e) => setSearchTerm(e.target.value)}
//                onKeyPress={(e) => {
//                  if (e.key === 'Enter') {
//                    handleSearch();
//                  }
//                }}
//                className={`border rounded px-3 py-2 text-sm w-64 ${
//                  darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300 bg-white text-gray-900'
//                }`}
//              />
//               <button 
//                 onClick={handleSearch}
//                 disabled={isSearching}
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400"
//               >
//                 <Search size={16} />
//                 {isSearching ? 'Searching...' : 'Search'}
//               </button>
//               {!isInitialLoad && (
//                  <button 
//                    onClick={() => {
//                      setSearchTerm('');
//                      loadInitialData();
//                    }}
//                    className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded text-sm"
//                  >
//                    Clear
//                  </button>
//                )}
//               <button 
//                 onClick={handleBulkDownload}
//                 disabled={selectedReports.length === 0}
//                 className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
//               >
//                 <Download size={16} />
//                 Download Selected ({selectedReports.length})
//               </button>
//               <button 
//                 onClick={handleBulkDownloadWithLogo}
//                 disabled={selectedReports.length === 0}
//                 className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
//               >
//                 <Download size={16} />
//                 Download Selected With Logo ({selectedReports.length})
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Table */}
//         <div className={`rounded-lg shadow overflow-hidden ${darkMode ? 'bg-gray-800 text-white border border-gray-700' : 'bg-white text-gray-900'}`}>
//           {error && (
//             <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 m-4 rounded">
//               {error}
//             </div>
//           )}

//           <div className="overflow-x-auto">
//             <table className="w-full">
//              <thead className={`${darkMode ? 'bg-gray-700 text-white border-b border-gray-600' : 'bg-gray-50 border-b'}`}>
//   <tr>
//     {/* Checkbox */}
//     <th className="px-4 py-3 text-left">
//       <input
//         type="checkbox"
//         checked={filteredReports.length > 0 && selectedReports.length === filteredReports.length}
//         onChange={handleSelectAll}
//         className="w-4 h-4 cursor-pointer"
//       />
//     </th>

//     {/* Patient ID */}
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
//       Patient ID
//     </th>

//     {/* Name */}
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
//       Name
//     </th>

//     {/* Institution Dropdown */}
//  <th
//   className={`px-2 py-3 text-left text-xs font-medium ${
//     darkMode ? "text-gray-300" : "text-gray-700"
//   } w-32`}   // <--- FIXED WIDTH (adjustable)
// >
//   <select
//     value={filterInstitution}
//     onChange={(e) => setFilterInstitution(e.target.value)}
//     disabled={loadingInstitutions}
//     className={`border rounded px-2 py-1 text-xs w-full overflow-x-auto whitespace-nowrap ${
//       darkMode
//         ? "bg-gray-600 border-gray-500 text-white"
//         : "border-gray-300 bg-white text-gray-900"
//     }`}
//     style={{
//       maxWidth: "120px",            // <--- Prevent dropdown from expanding too wide
//       overflowX: "auto",            // <--- Enable horizontal scroll
//       whiteSpace: "nowrap",         // <--- Prevent wrapping
//     }}
//   >
//     <option value="All">All Institution</option>

//     {loadingInstitutions ? (
//       <option disabled>Loading...</option>
//     ) : (
//       institutions.map((inst) => {
//         const instName = inst.name || inst;
//         return (
//           <option
//             key={inst.id || instName}
//             value={instName}
//             style={{
//               whiteSpace: "nowrap",
//             }}
//           >
//             {instName}
//           </option>
//         );
//       })
//     )}
//   </select>
// </th>


//     {/* Study Date Range */}
// <th
//   className={`px-4 py-3 text-left text-xs font-medium ${
//     darkMode ? "text-gray-300" : "text-gray-700"
//   }`}
// >
//   <input
//     type="date"
//     value={calendarDate} // yyyy-mm-dd for HTML date input
//     onChange={(e) => {
//       const val = e.target.value; // val = yyyy-mm-dd
//       setCalendarDate(val);

//       // If empty, clear the filter
//       if (!val) {
//         setStartDate("");
//         return;
//       }

//       // Convert back to dd-mm-yyyy for filter
//       const [yyyy, mm, dd] = val.split("-");
//       if (dd && mm && yyyy) {
//         setStartDate(`${dd}-${mm}-${yyyy}`);
//       }
//     }}
//     className={`border rounded px-2 py-1 text-xs ${
//       darkMode
//         ? "bg-gray-600 border-gray-500 text-white"
//         : "border-gray-300 bg-white text-gray-900"
//     }`}
//   />
// </th>

//     {/* Modality Dropdown */}
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
//       <select
//         value={filterModality}
//         onChange={(e) => setFilterModality(e.target.value)}
//         className={`border rounded px-2 py-1 text-xs ${
//           darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'border-gray-300 bg-white text-gray-900'
//         }`}
//       >
//         <option value="All">All Modality</option>
//         {modalities.map((m, i) => (
//           <option key={i} value={m}>{m}</option>
//         ))}
//       </select>
//     </th>

//     {/* Remaining Columns */}
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Location</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Radiologist</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>WhatsApp</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Email</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Actions</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Word Report</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Send Email</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Send WhatsApp</th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
//       Hindi PDF
//     </th>
//     <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Reports</th>
//   </tr>
// </thead>

//               <tbody className={darkMode ? 'divide-y divide-gray-700' : 'divide-y divide-gray-200'}>
//                 {(loading || isSearching) && reports.length === 0 ? (
//                   <tr>
//                     <td colSpan="15" className={`px-4 py-8 text-center ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
//                       {isSearching ? 'Searching...' : 'Loading...'}
//                     </td>
//                   </tr>
//                 ) : filteredReports.length === 0 ? (
//                   <tr>
//                     <td colSpan="12" className={`px-4 py-8 text-center ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
//                        {searchTerm ? 'No results found for your search' : 'No reports found'}
//                     </td>
//                   </tr>
//                 ) : (
//                  filteredReports.map((report, index) => (
//                    <tr key={`row-${index}`} className={darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}>
//                       <td className="px-4 py-3">
//                         <input
//                           type="checkbox"
//                           checked={selectedReports.includes(`${report.patient_id}-${index}`)}
//                           onChange={() => handleSelectReport(`${report.patient_id}-${index}`)}
//                           className="w-4 h-4 cursor-pointer"
//                         />
//                       </td>
//                       <td className="px-4 py-3 text-sm">{report.patient_id || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">{report.patient_name || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">{report.institution_name || 'null'}</td>
//                       <td className="px-4 py-3 text-sm">{report.study_date || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">
//                         <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
//                           {report.modality || 'N/A'}
//                         </span>
//                       </td>
//                       <td className="px-4 py-3 text-sm">{report.location || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">
//                         {report.radiologist?.length > 0 ? report.radiologist.join(', ') : 'N/A'}
//                       </td>
//                       <td className="px-4 py-3 text-sm">{report.whatsapp_number || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">{report.email || 'N/A'}</td>
//                       <td className="px-4 py-3 text-sm">
//                         <button
//                           onClick={async (e) => {
//                             e.stopPropagation();
//                             try {
//                               const fileKey = report.report_url; // 👈 correct key from your JSON
                        
//                               if (!fileKey) {
//                                 alert("No report available");
//                                 return;
//                               }
                        
//                               const urlResult = await CoordinatorHandler.getPresignedUrlComplete(fileKey);
                        
//                               if (urlResult.success && urlResult.url) {
//                                 window.open(urlResult.url, "_blank");
//                               } else {
//                                 alert("Failed to open report");
//                               }
//                             } catch (error) {
//                               console.error("Error opening report:", error);
//                               alert("Failed to open report");
//                             }
//                           }}
//                           className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 rounded text-xs"
//                         >
//                           DOWNLOAD
//                         </button>
//                         <button
//                           onClick={() => downloadWithLogo(report)}
//                           className="px-2 py-1 bg-green-600 text-white rounded text-xs"
//                         >
//                           Download With Logo
//                         </button>

//                       </td>
//                       <td className="px-4 py-3 text-sm">
//                       <button
//                         onClick={async () => {
//                           try {
//                             if (!report.patient_reports || report.patient_reports.length === 0) {
//                               alert("No report file URL found.");
//                               return;
//                             }
                      
//                             const fileUrl = encodeURIComponent(report.patient_reports[0].url
                              
//                             );
                      
//                             const response = await fetch(`${API_BASE_URL}/convert-pdf-to-word/?pdf_key=${fileUrl}`, {
//                               method: "GET",
//                               credentials: "include",
//                             });
                      
//                             if (!response.ok) throw new Error("Conversion failed");
                      
//                             const blob = await response.blob();
//                             const disposition = response.headers.get("content-disposition");
//                             let filename = "Converted_Report.doc";
//                             if (disposition && disposition.includes("filename=")) {
//                               filename = disposition.split("filename=")[1].replace(/"/g, "");
//                             }
                      
//                             const url = window.URL.createObjectURL(blob);
//                             const a = document.createElement("a");
//                             a.href = url;
//                             a.download = filename;
//                             document.body.appendChild(a);
//                             a.click();
//                             a.remove();
//                             window.URL.revokeObjectURL(url);
//                           } catch (err) {
//                             console.error("Word conversion error:", err);
//                             alert("Error converting PDF to Word");
//                           }
//                         }}
//                         className="flex items-center w-full gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 border-t border-gray-100"
//                       >
//                         📄 Convert to Word
//                       </button>
//                       </td>
                      
//                       <td className="px-4 py-3 text-sm">
//                         {report.patient_reports?.length > 0 ? (
//                           <button
//                             onClick={() => sendEmail(report)}
//                             disabled={!report.patient_reports?.[0]?.url || sending[`${report.id}-email`]}
//                             className={`px-3 py-1 rounded text-xs ${sending[`${report.id}-email`] ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 text-white'}`}
//                           >
//                             {sending[`${report.id}-email`] ? 'Sending...' : 'Send Email'}
//                           </button>
//                         ) : (
//                           'No PDF'
//                         )}
//                       </td>
//                       <td className="px-4 py-3 text-sm">
//                         {report.patient_reports?.length > 0 ? (
//                           <button
//                             onClick={() => sendWhatsapp(report)}
//                             disabled={!report.patient_reports?.[0]?.url || sending[`${report.id}-whatsapp`]}
//                             className={`px-3 py-1 rounded text-xs ${sending[`${report.id}-whatsapp`] ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-green-600 hover:bg-green-700 text-white'}`}
//                           >
//                             {sending[`${report.id}-whatsapp`] ? 'Sending...' : 'Send WhatsApp'}
//                           </button>
//                         ) : (
//                           'No PDF'
//                         )}
//                       </td>
//                       <td className="px-4 py-3 text-sm">
//                         <button
//                           onClick={() => translateToHindi(report)}
//                           className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded text-xs"
//                         >
//                           🇮🇳 Translate Hindi
//                         </button>
//                       </td>
//                       <td className="px-4 py-3 text-sm">
//                         {report.patient_reports?.length > 0 ? (
//                           <div className="flex flex-col gap-1">
//                             {report.patient_reports.map((rep, idx) => (
//                               <button
//                                 key={idx}
//                                onClick={async () => {
//                                  try {
//                                    // Use report.report_url directly since it's at the top level
//                                    const reportUrl = report.report_url || report.patient_reports?.[0]?.url;
                                   
//                                    if (!reportUrl) {
//                                      alert('No report available');
//                                      return;
//                                    }
                                   
//                                    const urlResult = await CoordinatorHandler.getPresignedUrlComplete(reportUrl);
//                                    if (urlResult.success && urlResult.url) {
//                                      window.open(urlResult.url, '_blank');
//                                    } else {
//                                      alert('Failed to open report');
//                                    }
//                                  } catch (error) {
//                                    console.error('Error opening report:', error);
//                                    alert('Failed to open report');
//                                  }
//                                }}
//                                 className="text-blue-600 hover:underline text-xs text-left"
//                               >
//                                 📥 Report {idx + 1}
//                               </button>
//                             ))}
//                           </div>
//                         ) : (
//                           'No reports'
//                         )}
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Load More Button */}
//           {nextCursor && isInitialLoad && (
//             <div className={`p-4 text-center ${darkMode ? 'border-t border-gray-700' : 'border-t'}`}>
//               <button
//                 onClick={loadMoreData}
//                 disabled={loading}
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded text-sm disabled:bg-gray-400 disabled:cursor-not-allowed"
//               >
//                 {loading ? 'Loading...' : 'Show More'}
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Pagination Info */}
//         <div className={`mt-4 text-sm text-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
//           Showing {filteredReports.length} of {reports.length} reports
//           {nextCursor && ' (More available)'}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PdfPage;




import React, { useState, useEffect } from 'react';
import { Download, Search, ChevronRight, ChevronLeft } from 'lucide-react';
import CoordinatorHandler from "../components/CoordinatorHandler";
import { API_BASE_URL } from '../../Api/apiconnector';
import { useNavigate } from 'react-router-dom';

const PdfPage = () => {
  const [reports, setReports] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Filter States
  const [searchTerm, setSearchTerm] = useState('');
  const [filterInstitution, setFilterInstitution] = useState('All');
  const [filterModality, setFilterModality] = useState("All");
  const [filterBodyPart, setFilterBodyPart] = useState("All"); // 🆕 Body Part State
  const [calendarDate, setCalendarDate] = useState(""); 
  
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedReports, setSelectedReports] = useState([]);
  const [sending, setSending] = useState({}); 
  const itemsPerPage = 200;
  
  const [institutions, setInstitutions] = useState([]);
  const [loadingInstitutions, setLoadingInstitutions] = useState(false);
  
  const [bodyParts, setBodyParts] = useState([]); // 🆕 Body Parts Array
  const [loadingBodyParts, setLoadingBodyParts] = useState(false);

  const [isSearching, setIsSearching] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  
  const navigator = useNavigate();
  const [darkMode, setDarkMode] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('pdfpage_darkmode')) || false;
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('pdfpage_darkmode', JSON.stringify(darkMode));
    } catch {}
  }, [darkMode]);

  // Load metadata once (Institutions + Body Parts)
  useEffect(() => {
    loadMetadata();
  }, []);

  // Reload data whenever dropdown filters change
  useEffect(() => {
    loadInitialData();
  }, [filterInstitution, filterModality, filterBodyPart, calendarDate]);

  // Helper to build current filters
  const getActiveFilters = () => ({
    search: searchTerm,
    institution: filterInstitution === 'All' ? '' : filterInstitution,
    modality: filterModality === 'All' ? '' : filterModality,
    bodyPart: filterBodyPart === 'All' ? '' : filterBodyPart, // 🆕 Apply Body Part
    date: calendarDate 
  });

  const loadMetadata = async () => {
    setLoadingInstitutions(true);
    setLoadingBodyParts(true);
    try {
      const [instData, bpData] = await Promise.all([
        CoordinatorHandler.getAllInstitutions(),
        CoordinatorHandler.getBodyParts().catch(() => [])
      ]);
      setInstitutions(Array.isArray(instData) ? instData : instData.results || instData.institutions || []);
      setBodyParts(Array.isArray(bpData) ? bpData : bpData.results || []);
    } catch (err) {
      console.error('Failed to load metadata:', err);
    } finally {
      setLoadingInstitutions(false);
      setLoadingBodyParts(false);
    }
  };

  const loadInitialData = async () => {
    setLoading(true);
    setError(null);
    setIsInitialLoad(true); 
    try {
      const data = await CoordinatorHandler.fetchCompletedTatCounters(
        itemsPerPage, 
        null, 
        getActiveFilters()
      );
      
      console.log('Fetched data:', data);
      setReports((data.results || []).map(r => {
        if (!Array.isArray(r.patient_reports)) {
          if (r.report_url) {
            return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
          }
          return { ...r, patient_reports: [] };
        }
        return r;
      }));
      setNextCursor(data.next_cursor);
      setSelectedReports([]); 
    } catch (err) {
      setError('Failed to load data. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadMoreData = async () => {
    if (!nextCursor || loading) return;
    
    setLoading(true);
    try {
      const data = await CoordinatorHandler.fetchCompletedTatCounters(
        itemsPerPage, 
        nextCursor, 
        getActiveFilters()
      );
      setReports(prev => [...prev, ...((data.results || []).map(r => {
        if (!Array.isArray(r.patient_reports)) {
          if (r.report_url) {
            return { ...r, patient_reports: [{ url: r.report_url, title: r.report_title || '' }] };
          }
          return { ...r, patient_reports: [] };
        }
        return r;
      }))]);
      setNextCursor(data.next_cursor);
      setCurrentPage(prev => prev + 1);
    } catch (err) {
      setError('Failed to load more data.');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    setIsSearching(true);
    await loadInitialData(); 
    setIsSearching(false);
  };

  const modalities = ['CR', 'DR', 'CT', 'MR', 'US', 'DX', 'PT', 'MG', 'XA'];

  // --- Actions & API calls ---
  
  const sendEmail = async (report) => {
    const pdf = report.patient_reports?.[0]?.url;
    if (!pdf) {
      alert('No PDF available to send.');
      return;
    }
    const key = `${report.id}-email`;
    setSending(prev => ({ ...prev, [key]: true }));
    const payload = {
      email: report.email || '',
      name: report.patient_name || '',
      pdf_key: pdf,
    };
    try {
      const res = await CoordinatorHandler.sendEmailPdfRaw(report.patient_id || '', payload);
      if (!res.success) throw new Error(res.error || 'Server error');
      alert('Email API triggered successfully.');
    } catch (err) {
      console.error('sendEmail error', err);
      alert('Failed to trigger email API. Check console for details.');
    } finally {
      setSending(prev => ({ ...prev, [key]: false }));
    }
  };

  const sendWhatsapp = async (report) => {
    const pdf = report.patient_reports?.[0]?.url;
    if (!pdf) {
      alert('No PDF available to send.');
      return;
    }
    const key = `${report.id}-whatsapp`;
    setSending(prev => ({ ...prev, [key]: true }));
    const payload = {
      whatsapp_number: report.whatsapp_number || report.whatsapp || '',
      patient_name: report.patient_name || '',
      pdf_key: pdf,
      patient_id: report.patient_id || '',
    };
    try {
      const res = await CoordinatorHandler.sendWhatsapp(payload);
      if (!res.success) throw new Error(res.error || 'Server error');
      alert('WhatsApp API triggered successfully.');
    } catch (err) {
      console.error('sendWhatsapp error', err);
      alert('Failed to trigger WhatsApp API. Check console for details.');
    } finally {
      setSending(prev => ({ ...prev, [key]: false }));
    }
  };

  const downloadReport = async (url, fileName) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName || 'report.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download failed:', err);
      window.open(url, '_blank');
    }
  };

  const translateToHindi = async (report) => {
    try {
      if (!report.report_id) {
        alert("Report ID not found");
        return;
      }
      const endpoint = `${API_BASE_URL}/reports/${report.report_id}/translate-hindi/`;
      const response = await fetch(endpoint, {
        method: "GET",
        credentials: "include",
      });

      if (!response.ok) throw new Error("Hindi translation failed");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const safeName = `${(report.patient_name || "Patient").replace(/\s+/g, "_")}_${report.patient_id}_HINDI.pdf`;

      link.href = blobUrl;
      link.download = safeName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Hindi translation error:", err);
      alert("Failed to generate Hindi report");
    }
  };

  const handleSelectReport = (reportId) => {
    setSelectedReports(prev => {
      if (prev.includes(reportId)) {
        return prev.filter(id => id !== reportId);
      } else {
        return [...prev, reportId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedReports.length === reports.length) {
      setSelectedReports([]);
    } else {
      setSelectedReports(reports.map((r, idx) => `${r.patient_id}-${idx}`));
    }
  };

  const handleBulkDownload = async () => {
    if (selectedReports.length === 0) {
      alert("Please select at least one report");
      return;
    }

    const pdfKeys = [];
    const nameMap = {};
    const selectedSet = new Set(selectedReports);
    
    reports.forEach((rep, idx) => {
      const reportId = `${rep.patient_id}-${idx}`;
      
      if (selectedSet.has(reportId) && rep.patient_reports?.length > 0) {
        rep.patient_reports.forEach((pdfReport, pdfIdx) => {
          const key = pdfReport.url;
          if (!key) return;
          pdfKeys.push(key);
          const safeName = `${(rep.patient_id || 'Patient')}_${(rep.patient_name || 'Unknown').replace(/\s+/g,'_')}_Report_${pdfIdx + 1}.pdf`;
          nameMap[key] = safeName;
        });
      }
    });

    if (pdfKeys.length === 0) {
      alert("No PDFs found in selected cases");
      return;
    }

    try {
      const endpoint = `${API_BASE_URL}/bulk-presigned-urls/`;
      const resp = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pdf_keys: pdfKeys }),
        credentials: "include"
      });

      if (!resp.ok) {
        const text = await resp.text().catch(() => null);
        throw new Error(`Backend returned ${resp.status} ${text || ''}`);
      }

      const data = await resp.json();
      const presigned = data.urls || [];
      
      if (!Array.isArray(presigned) || presigned.length === 0) {
        alert("No presigned URLs returned from server");
        return;
      }

      let delay = 0;
      const DELAY_BETWEEN = 500;
      
      presigned.forEach((item, itemIdx) => {
        const url = item.url;
        const key = item.key;
        const filename = nameMap[key] || (key ? key.split('/').pop() : `report_${itemIdx + 1}.pdf`);

        setTimeout(async () => {
          try {
            await downloadReport(url, filename);
          } catch (err) {
            console.error("Failed downloading", filename, err);
          }
        }, delay);

        delay += DELAY_BETWEEN;
      });

    } catch (err) {
      console.error("Bulk download failed", err);
      alert("Bulk download failed. See console for details.");
    }
  };

  const handleBulkDownloadWithLogo = async () => {
    if (selectedReports.length === 0) {
      alert("Please select at least one report");
      return;
    }

    const selectedSet = new Set(selectedReports);

    for (let idx = 0; idx < reports.length; idx++) {
      const rep = reports[idx];
      const reportId = `${rep.patient_id}-${idx}`;

      if (selectedSet.has(reportId)) {
        await downloadWithLogo(rep);
        await new Promise(res => setTimeout(res, 800)); 
      }
    }
  };
  
  const downloadWithLogo = async (report) => {
    try {
      const pdfKey = report?.patient_reports?.[0]?.url;
      if (!pdfKey) {
        alert("PDF not available");
        return;
      }
  
      const endpoint = `${API_BASE_URL}/download-with-logo/`;
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          pdf_key: pdfKey,
          patient_id: report.patient_id,
          patient_name: report.patient_name
        }),
      });
  
      if (!res.ok) throw new Error(`Server returned ${res.status}`);
  
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const safeName = `${report.patient_id}_${(report.patient_name || "Patient").replace(/\s+/g, '_')}_WITH_LOGO.pdf`;
  
      link.href = blobUrl;
      link.download = safeName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
  
    } catch (err) {
      console.error("Download-with-logo failed:", err);
      alert("Failed to download report with logo");
    }
  };


  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      {/* Header */}
      <header className={`px-6 py-4 flex justify-between items-center ${darkMode ? 'bg-gray-800 text-white border-b border-gray-700' : 'bg-white text-gray-900 border-b border-gray-200'}`}>
        <div className="flex items-center gap-4">
          <img
            src="https://u4rad.com/static/media/Logo.c9920d154c922ea9e355.png"
            alt="U4rad"
            style={{ height: 50, backgroundColor: darkMode ? 'white' : 'transparent', borderRadius: 6, padding: 2 }}
          />
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setDarkMode(!darkMode)}
            className={`px-3 py-2 rounded text-sm ${darkMode ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-700'}`}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <button
            onClick={() => navigator(-1)}
            title="Go back"
            className={`flex items-center justify-center w-25 h-10 rounded-md text-sm ${darkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
            <ChevronLeft size={18} />
            Go Back
          </button>
          <button onClick={() => navigator('/')} className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded text-sm text-white">
            Logout
          </button>
        </div>
      </header>

      {/* Main Content */}
      <div className="p-6">
        {/* Stats and Controls */}
        <div className={`rounded-lg shadow mb-6 p-4 ${darkMode ? 'bg-gray-800 text-white border border-gray-700' : 'bg-white text-gray-900'}`}>
          <div className="flex justify-between items-center flex-wrap gap-4">
            <div className="text-sm flex items-center gap-4">
              <span className="font-semibold">Loaded Reports: {reports.length}</span>
              {selectedReports.length > 0 && (
                <span className="text-blue-600 font-semibold">
                  {selectedReports.length} Selected
                </span>
              )}
            </div>
            
            <div className="flex gap-2 items-center flex-wrap">
             <input
               type="text"
               placeholder="Search by name or ID"
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
               onKeyPress={(e) => {
                 if (e.key === 'Enter') handleSearch();
               }}
               className={`border rounded px-3 py-2 text-sm w-64 ${
                 darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300 bg-white text-gray-900'
               }`}
             />
              <button 
                onClick={handleSearch}
                disabled={isSearching}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400"
              >
                <Search size={16} />
                {isSearching ? 'Searching...' : 'Search'}
              </button>
              {(searchTerm) && (
                 <button 
                   onClick={() => {
                     setSearchTerm('');
                     setTimeout(loadInitialData, 100);
                   }}
                   className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded text-sm"
                 >
                   Clear Search
                 </button>
               )}
              <button 
                onClick={handleBulkDownload}
                disabled={selectedReports.length === 0}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                <Download size={16} />
                Download Selected ({selectedReports.length})
              </button>
              <button 
                onClick={handleBulkDownloadWithLogo}
                disabled={selectedReports.length === 0}
                className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded text-sm flex items-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                <Download size={16} />
                Download Selected With Logo ({selectedReports.length})
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className={`rounded-lg shadow overflow-hidden ${darkMode ? 'bg-gray-800 text-white border border-gray-700' : 'bg-white text-gray-900'}`}>
          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 m-4 rounded">
              {error}
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="w-full">
             <thead className={`${darkMode ? 'bg-gray-700 text-white border-b border-gray-600' : 'bg-gray-50 border-b'}`}>
              <tr>
                <th className="px-4 py-3 text-left">
                  <input
                    type="checkbox"
                    checked={reports.length > 0 && selectedReports.length === reports.length}
                    onChange={handleSelectAll}
                    className="w-4 h-4 cursor-pointer"
                  />
                </th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Patient ID</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Name</th>

                {/* Institution Dropdown */}
                <th className={`px-2 py-3 text-left text-xs font-medium ${darkMode ? "text-gray-300" : "text-gray-700"} w-32`}>
                  <select
                    value={filterInstitution}
                    onChange={(e) => setFilterInstitution(e.target.value)}
                    disabled={loadingInstitutions}
                    className={`border rounded px-2 py-1 text-xs w-full overflow-x-auto whitespace-nowrap ${
                      darkMode ? "bg-gray-600 border-gray-500 text-white" : "border-gray-300 bg-white text-gray-900"
                    }`}
                    style={{ maxWidth: "120px", overflowX: "auto", whiteSpace: "nowrap" }}
                  >
                    <option value="All">All Institution</option>
                    {loadingInstitutions ? (
                      <option disabled>Loading...</option>
                    ) : (
                      institutions.map((inst) => {
                        const instName = inst.name || inst;
                        return (
                          <option key={inst.id || instName} value={instName} style={{ whiteSpace: "nowrap" }}>
                            {instName}
                          </option>
                        );
                      })
                    )}
                  </select>
                </th>

                {/* Study Date Range */}
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? "text-gray-300" : "text-gray-700"}`}>
                  <input
                    type="date"
                    value={calendarDate} 
                    onChange={(e) => setCalendarDate(e.target.value)}
                    className={`border rounded px-2 py-1 text-xs ${
                      darkMode ? "bg-gray-600 border-gray-500 text-white" : "border-gray-300 bg-white text-gray-900"
                    }`}
                  />
                </th>

                {/* Modality Dropdown */}
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  <select
                    value={filterModality}
                    onChange={(e) => setFilterModality(e.target.value)}
                    className={`border rounded px-2 py-1 text-xs ${
                      darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'border-gray-300 bg-white text-gray-900'
                    }`}
                  >
                    <option value="All">All Modality</option>
                    {modalities.map((m, i) => (
                      <option key={i} value={m}>{m}</option>
                    ))}
                  </select>
                </th>

                {/* 🆕 Body Part Dropdown Inserted Here */}
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  <select
                    value={filterBodyPart}
                    onChange={(e) => setFilterBodyPart(e.target.value)}
                    disabled={loadingBodyParts}
                    className={`border rounded px-2 py-1 text-xs w-full overflow-x-auto whitespace-nowrap ${
                      darkMode ? 'bg-gray-600 border-gray-500 text-white' : 'border-gray-300 bg-white text-gray-900'
                    }`}
                    style={{ maxWidth: "120px" }}
                  >
                    <option value="All">All Body Parts</option>
                    {loadingBodyParts ? (
                      <option disabled>Loading...</option>
                    ) : (
                      bodyParts.map((bp, i) => {
                        const bpName = bp.name || bp;
                        return <option key={i} value={bpName}>{bpName}</option>;
                      })
                    )}
                  </select>
                </th>

                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Location</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Radiologist</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>WhatsApp</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Email</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Actions</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Word Report</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Send Email</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Send WhatsApp</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Hindi PDF</th>
                <th className={`px-4 py-3 text-left text-xs font-medium ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Reports</th>
              </tr>
            </thead>

              <tbody className={darkMode ? 'divide-y divide-gray-700' : 'divide-y divide-gray-200'}>
                {(loading || isSearching) && reports.length === 0 ? (
                  <tr>
                    <td colSpan="17" className={`px-4 py-8 text-center ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                      {isSearching ? 'Searching...' : 'Loading...'}
                    </td>
                  </tr>
                ) : reports.length === 0 ? (
                  <tr>
                    <td colSpan="17" className={`px-4 py-8 text-center ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                       {searchTerm || calendarDate || filterInstitution !== "All" || filterModality !== "All" || filterBodyPart !== "All"
                         ? 'No results found for your filters' : 'No reports found'}
                    </td>
                  </tr>
                ) : (
                 reports.map((report, index) => (
                   <tr key={`row-${index}`} className={darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-50'}>
                      <td className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={selectedReports.includes(`${report.patient_id}-${index}`)}
                          onChange={() => handleSelectReport(`${report.patient_id}-${index}`)}
                          className="w-4 h-4 cursor-pointer"
                        />
                      </td>
                      <td className="px-4 py-3 text-sm">{report.patient_id || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">{report.patient_name || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">{report.institution_name || 'null'}</td>
                      <td className="px-4 py-3 text-sm">{report.study_date || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">
                        <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                          {report.modality || 'N/A'}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm">{report.body_part_examined || 'N/A'}</td> {/* 🆕 Body Part Cell */}
                      <td className="px-4 py-3 text-sm">{report.location || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">
                        {report.radiologist?.length > 0 ? report.radiologist.join(', ') : 'N/A'}
                      </td>
                      <td className="px-4 py-3 text-sm">{report.whatsapp_number || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">{report.email || 'N/A'}</td>
                      <td className="px-4 py-3 text-sm">
                        <button
                          onClick={async (e) => {
                            e.stopPropagation();
                            try {
                              const fileKey = report.report_url; 
                              if (!fileKey) {
                                alert("No report available");
                                return;
                              }
                              const urlResult = await CoordinatorHandler.getPresignedUrlComplete(fileKey);
                              if (urlResult.success && urlResult.url) {
                                window.open(urlResult.url, "_blank");
                              } else {
                                alert("Failed to open report");
                              }
                            } catch (error) {
                              console.error("Error opening report:", error);
                              alert("Failed to open report");
                            }
                          }}
                          className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-1 mb-1 rounded text-xs block w-full"
                        >
                          DOWNLOAD
                        </button>
                        <button
                          onClick={() => downloadWithLogo(report)}
                          className="px-2 py-1 bg-green-600 hover:bg-green-700 text-white rounded text-xs block w-full"
                        >
                          With Logo
                        </button>
                      </td>
                      <td className="px-4 py-3 text-sm">
                      <button
                        onClick={async () => {
                          try {
                            if (!report.patient_reports || report.patient_reports.length === 0) {
                              alert("No report file URL found.");
                              return;
                            }
                            const fileUrl = encodeURIComponent(report.patient_reports[0].url);
                            const response = await fetch(`${API_BASE_URL}/convert-pdf-to-word/?pdf_key=${fileUrl}`, {
                              method: "GET", credentials: "include",
                            });
                            if (!response.ok) throw new Error("Conversion failed");
                            
                            const blob = await response.blob();
                            const disposition = response.headers.get("content-disposition");
                            let filename = "Converted_Report.doc";
                            if (disposition && disposition.includes("filename=")) {
                              filename = disposition.split("filename=")[1].replace(/"/g, "");
                            }
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            window.URL.revokeObjectURL(url);
                          } catch (err) {
                            console.error("Word conversion error:", err);
                            alert("Error converting PDF to Word");
                          }
                        }}
                        className="flex items-center justify-center w-full gap-2 px-3 py-2 text-xs text-gray-700 hover:bg-gray-100 border-t border-gray-100 bg-white rounded"
                      >
                        📄 Convert
                      </button>
                      </td>
                      
                      <td className="px-4 py-3 text-sm">
                        {report.patient_reports?.length > 0 ? (
                          <button
                            onClick={() => sendEmail(report)}
                            disabled={!report.patient_reports?.[0]?.url || sending[`${report.id}-email`]}
                            className={`px-3 py-1 rounded text-xs ${sending[`${report.id}-email`] ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700 text-white'}`}
                          >
                            {sending[`${report.id}-email`] ? 'Sending...' : 'Send Email'}
                          </button>
                        ) : 'No PDF'}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        {report.patient_reports?.length > 0 ? (
                          <button
                            onClick={() => sendWhatsapp(report)}
                            disabled={!report.patient_reports?.[0]?.url || sending[`${report.id}-whatsapp`]}
                            className={`px-3 py-1 rounded text-xs ${sending[`${report.id}-whatsapp`] ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-green-600 hover:bg-green-700 text-white'}`}
                          >
                            {sending[`${report.id}-whatsapp`] ? 'Sending...' : 'Send WhatsApp'}
                          </button>
                        ) : 'No PDF'}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <button
                          onClick={() => translateToHindi(report)}
                          className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded text-xs"
                        >
                          🇮🇳 Hindi
                        </button>
                      </td>
                      <td className="px-4 py-3 text-sm">
                        {report.patient_reports?.length > 0 ? (
                          <div className="flex flex-col gap-1">
                            {report.patient_reports.map((rep, idx) => (
                              <button
                                key={idx}
                               onClick={async () => {
                                 try {
                                   const reportUrl = report.report_url || report.patient_reports?.[0]?.url;
                                   if (!reportUrl) { alert('No report available'); return; }
                                   const urlResult = await CoordinatorHandler.getPresignedUrlComplete(reportUrl);
                                   if (urlResult.success && urlResult.url) {
                                     window.open(urlResult.url, '_blank');
                                   } else { alert('Failed to open report'); }
                                 } catch (error) {
                                   console.error('Error opening report:', error);
                                   alert('Failed to open report');
                                 }
                               }}
                                className="text-blue-600 hover:underline text-xs text-left"
                              >
                                📥 Report {idx + 1}
                              </button>
                            ))}
                          </div>
                        ) : 'No reports'}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Load More Button */}
          {nextCursor && isInitialLoad && (
            <div className={`p-4 text-center ${darkMode ? 'border-t border-gray-700' : 'border-t'}`}>
              <button
                onClick={loadMoreData}
                disabled={loading}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded text-sm disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                {loading ? 'Loading...' : 'Show More'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfPage;